import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { combineReducers } from 'redux';

import operatingSystemReducer from './OperatingSystem/store/operatingSystemReducer';
import typicalProblemReducer from './TypicalProblem/store/typicalProblemReducer';
import printerReducer from './Printer/store/printerReducer';
import logoReducer from './Logo/store/logoReducer';
import filePatternReducer from './FilePattern/store/filePatternReducer';
import skuPatternReducer from './SKUPattern/store/skuPatternReducer';
import skuMappingReducer from './SKUMapping/store/skuMappingReducer';
import reportDataReducer from './ReportData/store/reportDataReducer';
import chassisTypeReducer from './ChassisType/store/chassisTypeReducer';
import notificationSettingReducer from './NotificationSetting/store/notificationSettingReducer';
import mailReducer from './Mail/store/mailReducer';
import gradeReducer from './Grade/store/gradeReducer';
import securazeAPiReducer from './SecurazeAPI/store/securazeApiReducer';
import deviceDataApiReducer from './DeviceDataApi/store/deviceDataApiReducer';
import authServiceReducer from './AuthService/store/authServiceReducer';

import OperatingSystem from './OperatingSystem';
import TypicalProblem from './TypicalProblem';
import Printer from './Printer';
import Logo from './Logo';
import FilePattern from './FilePattern';
import ReportData from './ReportData';
import ChassisType from './ChassisType';
import NotificationSetting from './NotificationSetting';
import Grade from './Grade';
import SecurazeAPI from './SecurazeAPI';
import Group from "../sc-group/Group";
import DeviceDataApi from './DeviceDataApi';
import CustomerDiagnoseCase from "./CustomerDiagnoseCase";
import AuthService from './AuthService';

export const routes = (basePath) => (
    <Switch>
        {<Route path={basePath + '/operatingSystems'} component={OperatingSystem} />}
        {<Route path={basePath + '/grades'} component={Grade} />}
        {<Route path={basePath + '/typicalProblems'} component={TypicalProblem} />}
        {<Route path={basePath + '/printers'} component={Printer} />}
        {<Route path={basePath + '/logos'} component={Logo} />}
        {<Route path={basePath + '/filePatterns'} component={FilePattern} />}
        {<Route path={basePath + '/reportData'} component={ReportData} />}
        {<Route path={basePath + '/chassisTypes'} component={ChassisType} />}
        {<Route path={basePath + '/notificationSettings'} component={NotificationSetting} />}
        {<Route path={basePath + '/securaze-api'} component={SecurazeAPI} />}
        {<Route path={basePath + '/group'} component={Group} />}
        {<Route path={basePath + '/device-data-api'} component={DeviceDataApi} />}
        {<Route path={basePath + '/customer-diagnose-case'} component={CustomerDiagnoseCase} />}
        {<Route path={basePath + '/auth-service'} component={AuthService} />}
        {/* {<Route path={basePath + '/mails'} component={Mail} />} */}
    </Switch>
);

export const subComponents = (translations) => [
    { name: translations["presets"] || "Presets", path: '/presets', permissions: ['presets_view'], subComponents: [
        { name: translations["general"] || "General", path: '/general', permissions: ['presets_view'] },
        { name: translations["mobile"] || "Mobile", path: '/mobile', permissions: ['presets_view'] },
        { name: translations["storage_product"] || "Single disk-drives", path: '/storage', permissions: ['presets_view'] },
        { name: translations["work"] || "Work", path: '/work', permissions: ['presets_view'] },
        { name: translations["work_verifier"] || "Work Verifier", path: '/workVerifier', permissions: ['presets_view'] },
    ] },
    { name: translations["installed_software"] || "Installed software", path: '/installed-software', permissions: ['installed_software_view'] },
    { name: translations["grading"] || "Grading", path: '/grading', permissions: ['grading_view'] },
    { name: translations["report_customization"] || "Report customization", path: '/report-customization', permissions: ['report_customization_view'] },
    { name: translations["sku"] || "SKU", path: '/sku', permissions: ['sku_view'] },
    { name: translations["printers"] || "Printers", path: '/printers', permissions: ['printer'] },
    { name: translations["network_zone"] || "Network zone", path: '/network-zone', permissions: ['network_zone_list'] },
    { name: translations["securaze_standards"] || "Securaze Standards", path: '/customer-erasure-method', permissions: ['customer_erasure_method_list'] },
    { name: translations["external_system_setting"] || "External system setting", path: "/external-system-setting", permissions: ["external_system_setting_list"] },
    { name: translations["securaze_api"] || "Securaze API", path: '/securaze-api', permissions: ['securaze_api'] },
    { name: translations["groups"] || "Groups", path: '/group', permissions: ['group_list'] },
    { name: translations["device_data_api"] || "Device Data API", path: '/device-data-api', permissions: ['device_data_api'] },
    { name: translations["diagnose_cases"] || "Diagnose cases", path: '/customer-diagnose-case', permissions: ['customer_diagnose_case_list'] },
    { name: translations["authorization_service"] || "Authorization Service", path: '/auth-service', permissions: ['auth_service'] },
    { name: translations["label_template"] || "Label template", path: '/label-template', permissions: ['label_template_list'] },
    { name: translations["device_case_preselection"] || "Device case preselection", path: '/device_case_preselection', permissions: ['device_case_preselection_list'] },
    // { name: translations["mails"] || "Mails", path: '/mails', permissions: ['mails'] },
];

export const reducers = combineReducers({
    operatingSystems: operatingSystemReducer,
    typicalProblems: typicalProblemReducer,
    printers: printerReducer,
    logos: logoReducer,
    filePatterns: filePatternReducer,
    skuPatterns: skuPatternReducer,
    skuMappings: skuMappingReducer,
    reportData: reportDataReducer,
    chassisTypes: chassisTypeReducer,
    notificationSettings: notificationSettingReducer,
    mails: mailReducer,
    grades: gradeReducer,
    securazeAPI: securazeAPiReducer,
    deviceDataApi: deviceDataApiReducer,
    authService: authServiceReducer
});
